<template>
  <div class="station">
    <div class="station_top"><slot></slot></div>
    <div class="station_text">
      <span>{{ item.name }}</span>
      <div class="btn">
        <p @click="update">修改</p>
        <p @click="del">删除</p>
      </div>
    </div>

    
  </div>
</template>
<script>


export default {
  props: ["station"],
  data() {
    return {
      openForm: false,
      item: {
        name: "aaa",
        x: 113,
        y: 22,
        radius: 50,
        address: "guandddsdg",
      },
     
    };
  },
  methods: {
    update(v) {
      this.$emit("update");
    },
    del(v) {
      this.$emit("del");
    },
  },
  mounted() {
    this.item = this.station;
  },
  watch: {
    station(v) {
      this.item = v;
    },
  },
};
</script>
<style>
.station {
  margin-right: auto;
}
.station:last-child {
  margin-right: 10px;
}
.station:first-child {
  margin-left: 10px;
}
.station:last-child .station_top {
  margin-right: 0px;
  background: #0ec90e;
  color: #fff;
  border: solid 1px #15de15;
}
.station:first-child .station_top {
  margin-right: 0px;
  background: #ee3636;
  color: #fff;
  border: solid 1px #dd4848;
}
.station_top {
  width: 20px;
  height: 20px;
  border: solid 1px #1990d0;
  background: #fff;
  border-radius: 50%;
  text-align: center;
  margin-bottom: 4px;
  line-height: 20px;
  font-size: 12px;
}
.end {
  background: #0ec90e;
  color: #fff;
  border: solid 1px #15de15;
}
.start {
  background: #0ec90e;
  color: #fff;
  border: solid 1px #15de15;
}
.station_text {
  position: relative;
}
.station_text span {
  line-height: 20px;
  width: 20px;
  height: 90px;
  writing-mode: tb-rl;
  line-height: 20px;
  overflow: hidden;
}
.station_text:hover {
  background: #dbe4ff;
}
.station_text .btn {
  display: none;
  position: absolute;
  right: -30px;
  top: 0;
  width: 30px;
  padding-left: 6px;
}
.station_text:hover .btn {
  display: block;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/tangci/station.vue